$(document).ready(function() {
    if($('.AuthorityToLeave').hasClass('checked')){
        $('.AuthorityToLeave').addClass("checked");
        $('.AuthorityToLeave').val("Yes");
        $('.AuthorityToLeave').prop( "checked", true);
    }
    $(".AuthorityToLeave").click(function() {
        var checked_status = this.checked;
        if (checked_status == true) {
            $(this).addClass("checked");
            $('.AuthorityToLeave').val("Yes");
        } else {
            $(this).removeClass("checked");
            $('.AuthorityToLeave').val("No");
        }
    });
});

//Blog filtering
  const liTags = document.querySelectorAll(".custom-blog-custom-tag li a");
  const activeLiIndex = localStorage.getItem('activeLiIndex');
  if (activeLiIndex) {
    liTags[activeLiIndex].classList.add('active');
  }
  liTags.forEach((li, index) => {
    li.addEventListener("click", function() {
      localStorage.setItem('activeLiIndex', index);
      liTags.forEach(otherLi => {
        otherLi.classList.remove("active");
      });
      li.classList.add("active");
    });
  });

// document.querySelector('div.custom-cart-order-note-toggle').click();

// open cart drawer
const triggerDrawer = document.querySelector(".cart-link");
const targetDrawer = document.querySelector("#openCartDrawer");
    triggerDrawer.addEventListener("click", function() {
      targetDrawer.classList.add("cc-popup--visible");
    });

document.addEventListener('DOMContentLoaded', function() {
  const cartButton = document.getElementById('cartButton');
  if (cartButton) {
    cartButton.addEventListener('click', function() {
      window.location.href = '/cart'; // Replace '/cart' with the URL of your cart page
    });
  }
});
